import { BrowserFeatureDetect } from './BrowserSupportAlert';

export { BrowserFeatureDetect as default };
